import { Backdrop, CircularProgress } from "@mui/material";
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import customParseFormat from "dayjs/plugin/customParseFormat";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { useLoaderData } from "react-router-dom";
 
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);

export const Loader = ({ loading }) => {
    return (
        <Backdrop
            open={loading}
            sx={(theme) => ({
                color: "#fff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
            })}
        >
            <CircularProgress />
        </Backdrop>
    );
};

export const sharedProps = {
    placeholder: '',
    InputProps: {
        sx: {
            fontSize: '12px',
            fontWeight: 500,
            '& .MuiSvgIcon-root': {
                fontSize: '18px',
                marginRight: '2px',
            },
        },
    },
    sx: {
        minWidth: 150,
        maxWidth: 150,
    },
};

export async function handleSessionOut() {
    const name = "sessionout";
    window.parent.postMessage(name, "*");
    await new Promise(resolve => setTimeout(resolve, 500));
};

export const DateFormater = (date) => {
    if (!date) return "";
    const d = dayjs(date instanceof Object && date.$d ? date.$d : date);
    return d.isValid() ? d.format("MM-DD-YYYY") : "";
};

export const ViewTransactionsRanges = () => {
    const { currentDate } = useLoaderData();
    dayjs.extend(quarterOfYear);

    // Use server date as the working day
    const today = dayjs(currentDate);

    const dateOptions = [
        {
            date: "Range",
            actualValue: {
                start: null,
                end: null
            }
        },
        {
            date: "Today",
            actualValue: {
                start: today.startOf("day"),
                end: today.endOf("day")
            }
        },
        {
            date: "Yesterday",
            actualValue: {
                start: today.subtract(1, "day").startOf("day"),
                end: today.subtract(1, "day").endOf("day")
            }
        },
        {
            date: "This Week",
            actualValue: {
                start: today.startOf("week"),
                end: today.endOf("week")
            }
        },
        {
            date: "This Week – to – Date",
            actualValue: {
                start: today.startOf("week"),
                end: today
            }
        },
        {
            date: "Last Week",
            actualValue: {
                start: today.subtract(1, "week").startOf("week"),
                end: today.subtract(1, "week").endOf("week")
            }
        },
        {
           
            date: "Last Week–to–Date",
            actualValue: {
                start: today.subtract(1, "week").startOf("week"),
                end: today.subtract(7, "day") 
            }
        },
        {
            date: "This Month",
            actualValue: {
                start: today.startOf("month"),
                end: today.endOf("month")
            }
        },
        {
            date: "This Month – to – Date",
            actualValue: {
                start: today.startOf("month"),
                end: today
            }
        },
        {
            date: "Last Month",
            actualValue: {
                start: today.subtract(1, "month").startOf("month"),
                end: today.subtract(1, "month").endOf("month")
            }
        },
        {
          
            date: "Last Month – to – Date",
            actualValue: {
                start: today.subtract(1, "month").startOf("month"),
                end: today.subtract(1, "month")
            }
        },
        {
            date: "This Quarter",
            actualValue: {
                start: today.startOf("quarter"),
                end: today.endOf("quarter")
            }
        },
        {
            date: "This Quarter – to – Date",
            actualValue: {
                start: today.startOf("quarter"),
                end: today
            }
        },
        {
            date: "Last Quarter",
            actualValue: {
                start: today.subtract(1, "quarter").startOf("quarter"),
                end: today.subtract(1, "quarter").endOf("quarter")
            }
        },
        {
         
            date: "Last Quarter – to – Date",
            actualValue: {
                start: today.subtract(1, "quarter").startOf("quarter"),
                end: today.subtract(1, "quarter")
            }
        },
        {
            date: "This Year",
            actualValue: {
                start: today.startOf("year"),
                end: today.endOf("year")
            }
        },
        {
            date: "This Year – to – Date",
            actualValue: {
                start: today.startOf("year"),
                end: today
            }
        },
        {
            date: "Last Year",
            actualValue: {
                start: today.subtract(1, "year").startOf("year"),
                end: today.subtract(1, "year").endOf("year")
            }
        },
        {
            // ✅ Corrected: same date last year
            date: "Last Year – to – Date",
            actualValue: {
                start: today.subtract(1, "year").startOf("year"),
                end: today.subtract(1, "year")
            }
        },
        {
            date: "Past 30 Days",
            actualValue: {
                start: today.subtract(30, "day"),
                end: today
            }
        }
    ];

    return dateOptions;
};

export const DateRangeEnum = {
    "This Week": 1,
    "Today": 2,
    "Range": 3,
    "This Month – to – Date": 4,
    "This Month": 5,
    "This Year": 6,
    "Last Week": 7,
    "Last Year": 8,
    "Past 30 Days": 9,
    "This Quarter – to – Date": 10,
    "This Year – to – Date": 11,
    "Recent": 12,
    "Last Week–to–Date": 13,
    "Last Quarter – to – Date": 14,
    "Last Month": 15,
    "This Quarter": 16,
    "Last Quarter": 17,
    "Last Month – to – Date": 18,
    "Yesterday": 19,
    "This Week – to – Date": 20,
    "Last Year – to – Date": 21,
    "Next Week": 22,
    "Next Month": 23,
    "Next Four Weeks": 24,
    "Next Quarter": 25,
    "Next Year": 26,
    "Custom": 27
};
